import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {FuseNavigationModule} from '@fuse/components/navigation/navigation.module';
import {TableSidebarComponent} from './table-sidebar.component';
import {ShowQrCodeModule} from '../../show-qr-code/show-qr-code.module';

@NgModule({
    declarations: [
        TableSidebarComponent
    ],
    imports: [
        RouterModule.forChild([]),
        MatIconModule,
        MatProgressBarModule,
        FuseNavigationModule,
        ShowQrCodeModule
    ],
    exports: [
        TableSidebarComponent
    ]
})
export class TableSidebarModule {
}
